<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: {
    type: [String, Boolean],
    required: true,
  },
  options: {
    type: Object,
    required: true,
  },
})

const indicator = computed(() => {
  return props.options.cases.find((c) => c.value === props.value)
})
</script>

<template>
  <div
    v-if="indicator"
    :class="indicator.classes"
    class="select-none rounded-full w-4 h-4"
    :title="indicator.title"
  >
  </div>
</template>
